// React import removed - not used

function RouteModeGuard({ children }) {
  return children;
}

export default RouteModeGuard;

